import Portal from '../service/portal'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 内容
    getmessages(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.getmessages(payload), {
        type: 'list',
        success,
        fail
      })
    },
    deletemessage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.deletemessage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getmessage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.getmessage(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addmessage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.addmessage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatemessage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.updatemessage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    // 首页设置
    getportalhomepage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.getportalhomepage(payload), {
        type: 'info',
        success,
        fail
      })
    },
    updateportalpage(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.updateportalpage(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getgoodslist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.getgoodslist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getpubablemessages(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Portal.getpubablemessages(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
